import { logger } from '@shared/lib/utils/logger'
/**
 * Pending Action Storage
 * Stores user actions that require authentication to resume after login/validation
 */

export type ActionType = 'contact_professional' | 'create_review' | 'edit_review' | 'delete_review'

export interface PendingAction {
  type: ActionType
  data: Record<string, unknown>
  timestamp: number
  returnPath: string // Path to return to after auth
  message?: string // Optional message to show after action
}

const PENDING_ACTION_KEY = 'professionals_pending_action'

export const actionStorage = {
  /**
   * Store a pending action
   */
  setPendingAction(action: PendingAction): void {
    try {
      localStorage.setItem(PENDING_ACTION_KEY, JSON.stringify(action))
    } catch (error) {
      logger.error('Failed to save pending action:', error)
    }
  },

  /**
   * Get pending action
   */
  getPendingAction(): PendingAction | null {
    try {
      const stored = localStorage.getItem(PENDING_ACTION_KEY)
      if (!stored) return null

      const action = JSON.parse(stored) as PendingAction

      // Expire actions older than 30 minutes
      const thirtyMinutes = 30 * 60 * 1000
      if (Date.now() - action.timestamp > thirtyMinutes) {
        this.clearPendingAction()
        return null
      }

      return action
    } catch (error) {
      logger.error('Failed to load pending action:', error)
      return null
    }
  },

  /**
   * Clear pending action
   */
  clearPendingAction(): void {
    try {
      localStorage.removeItem(PENDING_ACTION_KEY)
    } catch (error) {
      logger.error('Failed to clear pending action:', error)
    }
  },

  /**
   * Check if there's a pending action
   */
  hasPendingAction(): boolean {
    return !!this.getPendingAction()
  }
}
